<template>
  <div
    style="
      background-color: #333333;
      margin: 0 auto;
      padding-top: 30px;
      padding-bottom: 20px;
      color: #ffffff;
    "
    class="fm-aligncenter"
  >
    <el-row :gutter="20" style="width: 1200px">
      <el-col :span="6" class="col fm-center">
        <el-link
          class="title"
          :underline="false"
          target="_blank"
          href="https://intelure.com/"
          >智数服务</el-link
        >
        <el-link
          :underline="false"
          target="_blank"
          href="https://intelure.com/#/products"
          >智数产品</el-link
        >
        <el-link
          :underline="false"
          target="_blank"
          href="https://intelure.com/#/service"
          >数据服务</el-link
        >
        <el-link
          :underline="false"
          target="_blank"
          href="https://intelure.com/#/Informatization"
          >信息化咨询</el-link
        >
        <el-link
          :underline="false"
          target="_blank"
          href="https://intelure.com/#/customized"
          >定制服务</el-link
        >
      </el-col>
      <el-col :span="5" class="col fm-center">
        <div class="title">加入我们</div>
        <el-link
          :underline="false"
          target="_blank"
          href="https://intelure.com/#/about?id=third"
          >智数招聘</el-link
        >
      </el-col>
      <el-col :span="5" class="col fm-center">
        <div class="title">联系我们</div>
        <el-link
          :underline="false"
          target="_blank"
          href="https://intelure.com/#/about?id=fourth"
          >合作洽谈</el-link
        >
      </el-col>
      <el-col :span="8" class="col">
        <!--  <el-image @dragstart.prevent
          style="height: 125px; width: 125px"
          :src="require('@/assets/images/qywxqrcode.png')"
          fit="contain"
        ></el-image>  -->
        <div style="text-align: left">
          <div
            class="title fm-padding-bottom-20 fm-flex fm-aligncenter"
            style="cursor: auto"
          >
            关注我们：
            <el-popover placement="top" trigger="hover">
              <div class="gzhqrcode">
                <el-image
                  class="gzhqrcode_lt"
                  @dragstart.prevent
                  style="height: 85px; width: 85px"
                  :src="require('@/assets/images/gzhqrcode.png')"
                  fit="contain"
                ></el-image>
                <div class="gzhqrcode_rt">
                  <el-image
                    class="gzhqrcode_rt_logo"
                    @dragstart.prevent
                    style="height: 27px; width: 157px"
                    :src="require('@/assets/images/gzhqrcode-logo.svg')"
                    fit="contain"
                  ></el-image>
                  <div class="gzhqrcode_rt_name fm-flex">
                    <el-image
                      class="gzhqrcode_rt_icon"
                      @dragstart.prevent
                      style="height: 18px; width: 18px"
                      :src="require('@/assets/images/gzhqrcode-search.svg')"
                      fit="contain"
                    ></el-image>
                    <p class="gzhqrcode_rt_text">智数软件</p>
                  </div>
                </div>
              </div>

              <p slot="reference" class="fm-flex fm-aligncenter fm-pointer">
                <i
                  class="fm-icon fm-icon-weixin"
                  style="font-size: 20px; font-weight: normal; color: #1aad19"
                ></i>
                <span
                  class="fm-ml-5"
                  style="
                    font-size: 18px;
                    font-weight: normal;
                    color: #1aad19;
                    margin-left: 5px;
                  "
                  >公众号</span
                >
              </p>
            </el-popover>

            <el-popover placement="top" trigger="hover" class="fm-ml-20">
              <div class="fm-center">
                <div class="item-text">微信扫一扫关注视频号</div>
                <div class="item-text fm-margin-bottom-10">
                  了解更多产品详情及使用技巧
                </div>
                <el-image
                  @dragstart.prevent
                  style="height: 287px; width: 220px"
                  :src="require('@/assets/images/sphqrcode.png')"
                  fit="contain"
                ></el-image>
              </div>

              <p slot="reference" class="fm-flex fm-aligncenter fm-pointer">
                <i
                  class="fm-icon fm-icon-shipinhao"
                  style="font-size: 20px; font-weight: normal; color: #fa9d3b"
                ></i>
                <span
                  class="fm-ml-5"
                  style="
                    font-size: 18px;
                    font-weight: normal;
                    color: #fa9d3b;
                    margin-left: 5px;
                  "
                  >视频号</span
                >
              </p>
            </el-popover>
          </div>
          <div class="title fm-padding-bottom-10" style="cursor: auto">
            河北智数软件有限公司
          </div>
          <div class="fm-padding-bottom-5">
            地址：河北省邯郸市丛台区恒隆广场20层 21层
          </div>
          <div>E-MAIL：contact@intelure.com</div>
        </div>
      </el-col>
    </el-row>
    <div class="btm-text fm-margin-top-10 fm-margin-bottom-10">
      智数软件有限公司©
      <el-link
        class="btm-text"
        href="https://beian.miit.gov.cn/"
        type="primary"
      >
        冀ICP备2022017710号-6A
      </el-link>
    </div>
    <a
      class="btm-text fm-margin-bottom-10"
      href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=13040202000806"
    >
      <el-image
        @dragstart.prevent
        style="float: left"
        src="https://www.beian.gov.cn/img/new/gongan.png"
      ></el-image>
      <p
        class="btm-text"
        style="
          float: left;
          height: 20px;
          line-height: 20px;
          margin: 0px 0px 0px 5px;
          color: rgb(147, 147, 147);
        "
      >
        冀公网安备 13040202000806号
      </p>
    </a>
  </div>
</template>

<script>
export default {
  name: "Fastprintingv2WebFooter",

  data() {
    return {};
  },

  mounted() {},

  methods: {
    href(url) {
      window.open(url);
    },
  },
};
</script>

<style lang="scss" scoped>
.col > * {
  padding-bottom: 10px;
  text-align: center;
  color: #ffffff;
  font-size: 16px;
}
.title {
  font-size: 18px;
  font-weight: bold;
}

.btm-text {
  font-size: 16px;
  line-height: 18px;
}

.gzhqrcode {
  background: #07c160;
  border: none;
  height: 110px;
  margin: 0 auto;
  min-width: 291px;
  border-radius: 5px;
  display: inline-block;
  text-align: left;

  &_lt {
    margin: 12px 0 0 12px;
    background-color: #fff;
    width: 85px;
    float: left;
    border-radius: 4px;
  }

  &_rt {
    float: right;
    padding: 15px 17px 0 26px;

    &_logo {
      margin: 0 auto;
      width: 157px;
      height: 27px;
    }

    &_name {
      height: 34px;
      background: #ffffff;
      border-radius: 5px;
      margin-top: 14px;
      line-height: 34px;
      padding: 0 0 0 8px;
    }

    &_icon {
      width: 18px;
      height: 18px;
      :before {
        width: 18px;
        height: 18px;
      }
    }

    &_text {
      font-size: 16px;
      font-weight: 500;
      color: var(--fm-primary-text-color);
      padding: 0 0 0 5px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/login/LoginFooter.vue